import { z } from 'zod'

import { useTranslation } from '@flecto/translations'
import { type CoreUserTaxProfile } from '@flecto/types'

import { useTaxesInfo } from '../../taxes'

type UseTaxesSchemaOptions = {
  taxProfile?: Partial<CoreUserTaxProfile>
}

export function useTaxesSchema(options?: UseTaxesSchemaOptions) {
  const { t } = useTranslation('shared', { keyPrefix: 'validation' })
  const { userDefaultTaxBracket } = useTaxesInfo()

  const schema = z.object({
    default_taxable: z.boolean(),
    default_tax_rate: z
      .number()
      .or(z.string().min(2, { message: t('required') })),
    show_prices_with_tax: z.boolean(),
  })

  const initialValues: Partial<CoreUserTaxProfile> = {
    ...options?.taxProfile,
    default_tax_rate: userDefaultTaxBracket.value,
  }

  return { schema, initialValues }
}
